import { APIClient } from 'cx-api-client-lite';

/**
 * @typedef {function(payload: {}=): Promise<{data: {}, headers: {}, status: Number}>} ApiMethod
 */
/**
 * @typedef {Object} NewsAPIClient
 *
 * @description Use the following prefix in the method naming: POST -> create; GET -> get; DELETE -> delete; PATCH, PUT -> update;
 *
 * @property {ApiMethod} getNews
 */
/**
 * @type {NewsAPIClient | APIClient}
 */
const News = new APIClient({
  getNews: {
    path: '/{locale}/home-feed?top_news_n={top}&latest_news_n={latest}',
    method: 'GET',
  },
});

export default News;
